(function ($) {
  $.fn.primeButtonLoading = function (option, text) {
    return this.each(function () {
      if (!text) {
        text = '<i class="fa fa-refresh fa-spin"></i> Подождите';
      }


      if (!$(this).data('original-content')) {
        $(this).data('original-content', $(this).html());
      }

      if (option === true) {
        $(this).html(text);
        $(this).attr('disabled', true);
      } else {
        $(this).attr('disabled', false);
        $(this).html($(this).data('original-content'));
      }
    });
  };
}(jQuery));